"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden border-border shadow-sm">
            <div className="h-48 w-full animate-pulse bg-muted" />
            <CardHeader>
              <div className="h-4 w-24 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-3/4 animate-pulse rounded bg-muted" />
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <div className="h-4 w-full animate-pulse rounded bg-muted" />
                <div className="h-4 w-5/6 animate-pulse rounded bg-muted" />
              </div>
            </CardContent>
            <CardFooter>
              <div className="h-4 w-20 animate-pulse rounded bg-muted" />
            </CardFooter>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-muted-foreground">
          Unable to load recent news at this time.
        </p>
        <button onClick={refetch} className="text-ring font-medium hover:underline">
          Try Again
        </button>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground">No recent news available.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="flex h-full flex-col overflow-hidden border-border shadow-sm transition-shadow hover:shadow-md">
          {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-56 w-full object-cover" /> : <div className="flex h-56 w-full items-center justify-center bg-muted">
              <span className="text-muted-foreground">No Image Available</span>
            </div>}
          <CardHeader className="flex-none">
            {post.date && <CardDescription className="font-sans text-sm text-muted-foreground">
                {new Date(post.date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
          })}
              </CardDescription>}
            <CardTitle className="font-sans text-xl font-semibold text-primary line-clamp-2">
              {post.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="flex-grow">
            <div className="font-sans text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />
          </CardContent>
          <CardFooter className="flex-none pt-0">
            <Link to={post.link || "#"} className="font-sans font-medium text-ring transition-colors hover:text-primary hover:underline">
              Read More
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function RecentCommunityNews() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="recent-community-news" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="mb-4 font-sans text-3xl font-bold text-primary md:text-4xl">
            Recent Community News
          </h2>
          <p className="mx-auto max-w-2xl font-sans text-muted-foreground">
            Stay updated with the latest events, activities, and stories from our
            Moonrise Residential Care family.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <NewsConsumer />
        </PostsProvider>
      </div>
    </section>;
}